import img1 from '../assets/images/oursolution/img1.png';
import img2 from '../assets/images/oursolution/img2.jpg';
import img3 from '../assets/images/oursolution/img3.jpg';
import img4 from '../assets/images/oursolution/img4.png';
import img5 from '../assets/images/oursolution/img5.jpg';
import img6 from '../assets/images/oursolution/img6.jpg';
import securityVideo from '../assets/videos/services/IT_Security.mp4';
import fireVideo from '../assets/videos/services/FIRE.mp4';
import hvacVideo from '../assets/videos/services/HAVC_Cooling_Technology_Visualization.mp4';
import itInfrastructureVideo from '../assets/videos/services/cool-care-home-page.mp4';
import solarVideo from '../assets/videos/services/Solar_Innovation_Eco_Energy_Video.mp4';
import maintenanceVideo from '../assets/videos/services/Maintenance.mp4';

export type SolutionItem = {
  id: number;
  slug: string;
  tag: string;
  title: string;
  description: string;
  image: string;
  video?: string;
  brochurePdf: string;
  detailTitle: string;
  detailDescription: string;
  subCategories: string[];
  technologyPartners: string[];
  applications: string[];
};

export const ourSolutionData: SolutionItem[] = [
  {
    id: 1,
    slug: 'security-and-surveillance',
    tag: 'CCTV - ACCESS CONTROL - INTRUSION DETECTION',
    title: 'Security & Surveillance',
    description:
      'State-of-the-art physical security systems for mining, government, corporate, and urban environments.',
    image: img1,
    video: securityVideo,
    brochurePdf: '/assets/Pdfs/pdf.pdf',
    detailTitle: 'CCTV, Access Control & Intrusion Detection',
    detailDescription:
      'State-of-the-art physical security systems for mining, government, corporate, and urban environments. We combine advanced camera technology with intelligent monitoring.',
    subCategories: ['IP & Analog CCTV', 'Access Control', 'Intrusion Detection', 'Video Analytics', 'Perimeter Security'],
    technologyPartners: ['Hikvision', 'Dahua Technology', 'AJAX Systems', 'Yale', 'Matrix Comsec'],
    applications: ['Mining Sites', 'City Surveillance', 'Government Properties', 'Airports']
  },
  {
    id: 2,
    slug: 'fire-protection',
    tag: 'DETECTION - SUPPRESSION - ALARM SYSTEMS',
    title: 'Fire Protection',
    description: 'Comprehensive fire safety solutions tailored to every fire type.',
    image: img2,
    video: fireVideo,
    brochurePdf: '/assets/Pdfs/pdf.pdf',
    detailTitle: 'Detection, Suppression & Alarm Systems',
    detailDescription:
      'Comprehensive fire safety solutions tailored to every fire type. While most companies offer one solution for all fires, we provide specialized solutions for each type.',
    subCategories: ['Fire Detection', 'Fire Suppression', 'Fire Alarms', 'Vehicle Fire Systems', 'Gas Suppression'],
    technologyPartners: ['Dafo Vehicle Fire Suppression', 'Ceasefire Industries', 'Kanex Fire'],
    applications: ['Commercial Buildings', 'Industrial Warehouses', 'Mining Operations', 'Data Centers']
  },
  {
    id: 3,
    slug: 'hvac-solutions',
    tag: 'VRF - DUCT SYSTEMS - CLIMATE CONTROL',
    title: 'HVAC Solutions',
    description:
      'Energy-efficient heating, ventilation, and air conditioning systems designed for the DRC climate, ensuring optimal performance in commercial and industrial environments.',
    image: img3,
    video: hvacVideo,
    brochurePdf: '/assets/Pdfs/pdf.pdf',
    detailTitle: 'VRF Systems, Duct & Climate Control',
    detailDescription:
      'Energy-efficient heating, ventilation, and air conditioning systems designed for the DRC climate, ensuring optimal performance in commercial and industrial environments.',
    subCategories: ['VRF Systems', 'Duct Installation', 'Dehumidification', 'Air Cleaning', 'Building Controls'],
    technologyPartners: ['Trane Technologies', 'Lutron', 'Delta UPS'],
    applications: ['Office Complexes', 'Hotels', 'Industrial Facilities', 'Retail Spaces']
  },
  {
    id: 4,
    slug: 'it-infrastructure',
    tag: 'NETWORKING - SERVERS - TELECOM - SOFTWARE',
    title: 'IT Infrastructure',
    description:
      'Enterprise-grade IT systems including networking, servers, cybersecurity, unified communications, and business software solutions.',
    image: img4,
    video: itInfrastructureVideo,
    brochurePdf: '/assets/Pdfs/pdf.pdf',
    detailTitle: 'Networking, Servers, Telecom & Software',
    detailDescription:
      'Enterprise-grade IT systems including networking, servers, cybersecurity, unified communications, and business software solutions.',
    subCategories: [
      'Network Infrastructure',
      'Server Solutions',
      'Cybersecurity',
      'Unified Communications',
      'Business Software'
    ],
    technologyPartners: [
      'Cisco',
      'IBM',
      'HP',
      'Dell Technologies',
      'Microsoft',
      'Oracle',
      'Fortinet',
      'Sophos',
      'Quick Heal',
      'Seqrite',
      'NETGEAR',
      'Ruckus Networks',
      'Yealink',
      'Zoho',
      'LogicalDOC'
    ],
    applications: ['Corporate Offices', 'Data Centers', 'Government', 'Healthcare']
  },
  {
    id: 5,
    slug: 'solar-energy',
    tag: 'STREETLIGHTS - PANELS - OFF-GRID POWER',
    title: 'Solar Energy',
    description:
      'Reliable solar-powered solutions reducing energy costs and increasing operational independence for businesses across the DRC.',
    image: img5,
    video: solarVideo,
    brochurePdf: '/assets/Pdfs/pdf.pdf',
    detailTitle: 'Streetlights, Panels & Off-Grid Power',
    detailDescription:
      'Reliable solar-powered solutions reducing energy costs and increasing operational independence for businesses across the DRC.',
    subCategories: ['Solar Streetlights', 'Commercial Panels', 'Off-Grid Systems', 'Inverters & Storage'],
    technologyPartners: ['Delta UPS', 'Trane Technologies'],
    applications: ['Street Lighting', 'Mining Camps', 'Commercial Buildings', 'Remote Facilities']
  },
  {
    id: 6,
    slug: 'maintenance-support',
    tag: 'WARRANTY - POST-WARRANTY - LIFECYCLE',
    title: 'Maintenance & Support',
    description:
      'Full lifecycle maintenance for all hardware and software we supply — keeping your systems at peak performance with both warranty and post-warranty coverage.',
    image: img6,
    video: maintenanceVideo,
    brochurePdf: '/assets/Pdfs/pdf.pdf',
    detailTitle: 'Warranty, Post-Warranty & Lifecycle Service',
    detailDescription:
      'Full lifecycle maintenance for all hardware and software we supply — keeping your systems at peak performance with both warranty and post-warranty coverage.',
    subCategories: ['Preventive Maintenance', 'Emergency Repairs', 'System Upgrades', 'Software Updates'],
    technologyPartners: ['All Partner Brands'],
    applications: ['All Industries', 'All Equipment Types']
  }
];
